<template>
  <d-form>
    <d-form-row class="form-group">
      <d-col cols="12" md="9">
        <label>Título:</label>
        <d-form-input type="text" v-model="model.name" :state="hasErrorFiled('name')"/>
        <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
      </d-col>
      <d-col cols="12" md="3">
        <label>Ordem:</label>
        <d-form-input type="number" v-model="model.order"/>
      </d-col>
    </d-form-row>
    <d-form-row class="form-group">
      <d-col cols="12">
        <label>Url:</label>
        <d-form-input type="text" v-model="model.url"/>
      </d-col>
    </d-form-row>
    <d-form-row class="form-group">
      <d-col cols="12">
        <label>Imagem:</label>
        <upload-image :model.sync="model"/>
      </d-col>
    </d-form-row>
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { cloneDeep, stringfy, getDateTimeUTCISO } from '_utils';
import UploadImage from '_shared/UploadImage.vue';
import mixin from '_common/mixins/ValidateForm';
import BannerService from '_services/rest/modules/banner';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import {
  MODEL,
  _LOAD_MODEL_,
} from './BannerModel';

export default {
  name: 'banner-form',
  mixins: [mixin],
  components: {
    UploadImage,
    ConfirmationModal,
  },
  computed: {
    status() {
      const { status } = this.$store.state.puzzle;
      if (status.length) {
        return status;
      }
      return [];
    },
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      errors: {
        name: { required: false },
      },
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getStatusList',
    ]),
    getOptions() {
      if (this.status.length === 0) {
        this.getStatusList();
      }
    },
    draft() {
      this.model.status_id = 1;
      this.save();
    },
    publish() {
      this.model.status_id = 2;
      this.model.published_date = new Date();
      this.save();
    },
    save() {
      if (this.checkForm()) {
        this.model.slug = stringfy(this.model.name);
        this.model.published_date = getDateTimeUTCISO(this.model.published_date);
        BannerService.save(this.model)
          .then(response => {
            this.$router.push({ name: 'admin-banner-edit', params: { bannerId: response.data.id } });
          })
          .catch(error => {
            this.activeAlert({ message: error.message, theme: 'danger' });
          });
      }
    },
  },
  mounted() {
    this.getOptions();
    this._onLoadModel = model => { this.model = model; };
    Events.$on(_LOAD_MODEL_, this._onLoadModel);
  },
  beforeDestroy() {
    Events.$off(_LOAD_MODEL_, this._onLoadModel);
  },
};
</script>

<style lang="scss" scoped>

</style>
